/*
  Author: Piyush Dubey
*/
const data = {
    nonSSO: [
        "local",
        "v2",
        "expense",
        "vendor",
        "localhost",
        "travel",
        "v2-uat",
        "expense-uat",
        "v2-prep",
        "expense-prep",
        "expense-sdx",
        "dev-icici-prep-crd",
        "v2-new-ui",
        "segfault1",
        "v2-nui-prep",
        "hdfcbank.poweredby",
        "uat-hdfcbank.poweredby"
    ],
    isSSO: function() {
        const hostName = window.location.hostname;
        let subDomain = hostName.split(".")[0];
        if (hostName.includes("hdfcbank.poweredby")) {
            // This logic is for HDFC poweredby
            subDomain = hostName.substring(0, hostName.indexOf(".happay.in"));
        }
        return !this.nonSSO.includes(subDomain);
    }
};

export default data;
